<template>
  <div class="support-box-item flex flex-align-top flex-justify-between flex-wrap-wrap">
    <div
      class="support-item flex-0 flex flex-v flex-align-center"
      v-for="(item, $index) in supportList"
      :key="$index"
    >
      <img class="support-img" :src="item.img" alt="" />
      <div class="support-name">{{ item.name }}</div>
      <div class="support-desc" v-html="item.desc"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    let supportList = [
      {
        name: '广泛市场覆盖',
        desc: '国内覆盖360座城市<br/>市场持续开拓中',
        img: require('../../assets/img/index/support/ic_for_1.png'),
      },
      {
        name: '海量运力共享',
        desc: '平台百万司机车辆资源<br/>加入即可满足多样化需求',
        img: require('../../assets/img/index/support/ic_for_2.png'),
      },
      {
        name: '分钟级数据同步',
        desc: '城市、车型、价格<br/>即时刷新同步',
        img: require('../../assets/img/index/support/ic_for_3.png'),
      },
      {
        name: '水波式智能推送原则',
        desc: '优先推送3公里范围内优质司机接单<br/>智能算法，订单需求快速响应',
        img: require('../../assets/img/index/support/ic_for_4.png'),
      },
      {
        name: '车辆路线规划',
        desc: '结合大数据和实时路况合理安排<br/>车辆行驶路线规划',
        img: require('../../assets/img/index/support/ic_for_5.png'),
      },
      {
        name: '准确地址定位',
        desc: '根据关键字智能推送地址列表<br/>快速精准定位',
        img: require('../../assets/img/index/support/ic_for_6.png'),
      },
      {
        name: '安全强大的平台能力',
        desc: '安全可靠的平台服务<br/>丰富完善的API接口输出能力',
        img: require('../../assets/img/index/support/ic_for_7.png'),
      },
      {
        name: '全方位的技术咨询',
        desc: '为合作伙伴提供坚实的B端<br/>产品技术支持及咨询能力',
        img: require('../../assets/img/index/support/ic_for_8.png'),
      },
    ];
    return {
      supportList,
    };
  },
};
</script>

<style lang="scss" scoped>
.support-box-item {
  padding: 41px 32px 20px;
}
.support-item {
  width: 25%;
  padding: 27px 0 30px;
  margin-right: -1px;
  text-align: center;
  border-top: 1px solid #eee;
  border-right: 1px solid #eee;
  &:nth-child(4n) {
    border-right: none;
    margin-right: 0; // flex布局居中后hover时遮住border
  }
  &:nth-child(-n + 4) {
    border-top: none;
  }
  &:hover {
    box-shadow: 0 2px 10px 2px rgba(0, 0, 0, 0.1);
    .support-name {
      color: #f16622;
    }
  }
  .support-img {
    width: 76px;
    height: 65px;
    vertical-align: top;
  }
  .support-name {
    margin-top: 20px;
    color: #393939;
    font-size: 16px;
    font-weight: bold;
  }
  .support-desc {
    margin-top: 21px;
    color: #7c7c7c;
    font-size: 12px;
    line-height: 18px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/index/support.vue